import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mb-2 ml-2 fw-bold" };
const _hoisted_2 = { class: "fw-bold" };
const _hoisted_3 = { class: "mb-4 data-box__select" };
const _hoisted_4 = { class: "item" };
const _hoisted_5 = ["value"];
const _hoisted_6 = ["src"];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
    key: 0,
    class: "item-secondary"
};
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_12 = { class: "text-muted" };
const _hoisted_13 = {
    key: 1,
    class: "item-secondary"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$tc('client.Commerce.Carts.PaymentMode')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.payments, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                name: "paymentMethod",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.payment.methodID) = $event)),
                                value: item.name
                            }, null, 8, _hoisted_5), [
                                [_vModelRadio, _ctx.data.payment.methodID]
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            (item.logoSmall)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.logoSmall,
                                    border: "0"
                                }, null, 8, _hoisted_6))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.caption), 1))
                        ]),
                        (item.logoIcon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("img", {
                                    src: item.logoIcon,
                                    alt: item.caption,
                                    border: "0"
                                }, null, 8, _hoisted_9)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.data?.payment?.methodID === item.name && item.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(item.description), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.data?.payment?.methodID === item.name && item.method.componentName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", null, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.method.componentName), {
                                    gateway: item.gateway,
                                    method: item.method
                                }, null, 8, ["gateway", "method"]))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 64));
            }), 256))
        ])
    ], 64));
}
